import Header from './Header'
import HomePage from './HomePage'
import Homecontent from './Homecontent'
import './Header.css'
import Footer from './Footer'

function Home() {
  return (
    <>
    
    <div className='main'>
      <div className='back mb-5'>
       <div className="header-background">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
        <div className="blob blob-4"></div>
        <div className="blob blob-5"></div>
        <div className="blob blob-6"></div>
         <div className="blob blob-7"></div>
         <div className="blob blob-8"></div>
    </div>
      <Header/> 
      <HomePage/>
    <Homecontent/>
    </div>
    <Footer/>
    </div>
    </>
  )
}

export default Home
